import React from 'react';
import { Page } from '../../../../../shared/Components/Page';
import {LogImportacionesContainer} from './Screen';

export const LogImportacionesView = () =>{

    return (
        <Page title={'Log Importaciones'} scrollBody>{<LogImportacionesContainer/>}</Page>
    )
}